/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect } from 'react';
import { postFile, get } from 'lib/request';
import { submit } from 'lib/utility';
import FormStore, { handleChange } from 'lib/stores/formStore';
import ConfigStore from 'lib/stores/configStore';
import ValidationStore from 'lib/stores/validationStore';
import Progress from 'lib/components/Progress';
import SubmitButton from 'lib/components/SubmitButton';
import Form from 'lib/components/Form';

const ResidentPhoto = ({ onAfterSubmit }) => {
  const { resident, resident_photo } = FormStore.useState(state => state);
  const currentPage = ConfigStore.useState(state => state.currentPage);
  const validation = ValidationStore.useState(state => state[currentPage]);

  const uploadPhoto = async () => {
    const data = new FormData();

    data.append('photo[image]', resident_photo.image);
    data.append('photo[name]', resident_photo.name);

    await postFile(`/hosts/residents/${resident.id}/add_photo`, data);
  };

  const onSubmit = async e => {
    e.preventDefault();

    submit(async () => {
      await uploadPhoto();

      const response = await get('/hosts/residents.json');

      FormStore.update(state => {
        state.residents = response.data;
        state.resident = {};
        state.resident_photo = {};
      });

      if (onAfterSubmit) await onAfterSubmit();
    }, 'Uploading');
  };

  useEffect(() => {
    handleChange(`${resident.given_names} ${resident.family_name}`, 'resident_photo.name');
  }, [resident]);

  return (
    <form id="residentPhotoForm" onSubmit={onSubmit}>
      <div className="mb-3">
        <Form.ImageUploader
          name="resident_photo.image"
        />
        <Progress />
      </div>

      <SubmitButton
        formId="residentPhotoForm"
        testid="residentPhotoUploadButton"
        disabled={validation.image ? !validation.image.valid : true}
        label="Upload"
      />
    </form>
  );
};

export default ResidentPhoto;
